import React, { Component } from 'react';
import Header from './Header';
import Footer from './Footer';
import {Pie} from 'react-chartjs-2';
import superagent from 'superagent';
import ReactLoading from 'react-loading';
import Modal from 'react-responsive-modal';
import {NavLink, Link} from 'react-router-dom';


class Dashboard extends Component {
    constructor(props) {
        super(props);



        this.state={
           user_details:this.props.user_details,
           access_token:this.props.access_token,
           loading:false,
           api_error:false,
           loaded_successfully:false,
           api_error_message:"",

        }
     }

  render() {
    const _this=this;

    return (
      <div className="main-panel">

        <Header title ="My Profile" />

        <div className="content">
            <div className="container-fluid">
                <div className="row">

                    <div className="col-lg-12 col-md-12">
                        <div className="card">
                            <div className="card-header card-header-primary">
                                <h4 className="card-title text-center">My Profile</h4>
                            </div>
                            <div className="card-body">

                            <div className = "row col-lg-12 col-sm-12 col-sm-12">

                                <div className = "col-lg-7">
                                      <div className = "row col-lg-12 col-md-12 content-line">
                                          <span className = "col-lg-5 content-titles">
                                              Admission Number :
                                          </span>
                                          <span className = "col-lg-7 content-text">
                                            {_this.props.student_details.core_details.AdmnNo}
                                          </span>
                                      </div>

                                      <div className = "row col-lg-12 col-md-12 content-line">
                                          <span className = "col-lg-5 content-titles content-line">
                                              Name :
                                          </span>
                                          <span className = "col-lg-7 content-text ">
                                            {_this.props.student_details.core_details.names}
                                          </span>
                                      </div>

                                      <div className = "row col-lg-12 col-md-12 content-line">
                                          <span className = "col-lg-5 content-titles">
                                              Programme :
                                          </span>
                                          <span className = "col-lg-7 content-text ">
                                            {_this.props.student_details.class_details.programme}
                                          </span>
                                      </div>

                                      <div className = "row col-lg-12 col-md-12 content-line">
                                          <span className = "col-lg-5 content-titles">
                                              Study Level:
                                          </span>
                                          <span className = "col-lg-7 content-text">
                                            {_this.props.student_details.core_details.StudyLevel}
                                          </span>
                                      </div>

                                      <div className = "row col-lg-12 col-md-12 content-line">
                                          <span className = "col-lg-5 content-titles">
                                              Year :
                                          </span>
                                          <span className = "col-lg-7 content-text ">
                                            {_this.props.student_details.class_details.Year}
                                          </span>
                                      </div>

                                      <div className = "row col-lg-12 col-md-12 content-line">
                                          <span className = "col-lg-5 content-titles">
                                              Term :
                                          </span>
                                          <span className = "col-lg-7 content-text">
                                            {_this.props.student_details.class_details.Semester}
                                          </span>
                                      </div>

                                      <div className = "row col-lg-12 col-md-12 content-line">
                                          <span className = "col-lg-5 content-titles">
                                              Class :
                                          </span>
                                          <span className = "col-lg-7 content-text">
                                            {_this.props.student_details.core_details.class}
                                          </span>
                                      </div>

                                      <div className = "row col-lg-12 col-md-12 content-line">
                                          <span className = "col-lg-5 content-titles">
                                              Category:
                                          </span>
                                          <span className = "col-lg-7 content-text">
                                            {_this.props.student_details.core_details.SType}
                                          </span>
                                      </div>

                                      <div className = "row col-lg-12 col-md-12 content-line">
                                          <span className = "col-lg-5 content-titles">
                                              School :
                                          </span>
                                          <span className = "col-lg-7 content-text">
                                            {_this.props.student_details.core_details.School}
                                          </span>
                                      </div>

                                      <div className = "row col-lg-12 col-md-12 content-line">
                                          <span className = "col-lg-5 content-titles">
                                              Campus :
                                          </span>
                                          <span className = "col-lg-7 content-text">
                                            {_this.props.student_details.core_details.Campus}
                                          </span>
                                      </div>

                                </div>



                                <div className = "col-lg-5">
                                      <div className = "row col-lg-12 col-md-12 content-line">
                                          <span className = "col-lg-5 content-titles">
                                              Email:
                                          </span>
                                          <span className = "col-lg-7 content-text content-line">
                                            {_this.props.student_details.core_details.email}
                                          </span>
                                      </div>

                                      <div className = "row col-lg-12 col-md-12 content-line">
                                          <span className = "col-lg-5 content-titles">
                                              Gender:
                                          </span>
                                          <span className = "col-lg-7 content-text">
                                            {_this.props.student_details.core_details.gender}
                                          </span>
                                      </div>

                                      <div className = "row col-lg-12 col-md-12 content-line">
                                          <span className = "col-lg-5 content-titles">
                                              Telephone Number:
                                          </span>
                                          <span className = "col-lg-7 content-text">
                                            {_this.props.student_details.core_details.telno}
                                          </span>
                                      </div>

                                      <div className = "row col-lg-12 col-md-12 content-line">
                                          <span className = "col-lg-5 content-titles">
                                              National ID:
                                          </span>
                                          <span className = "col-lg-7 content-text">
                                            {_this.props.student_details.core_details.nationalID}
                                          </span>
                                      </div>
                                      <div className = "row col-lg-12 col-md-12 content-line">
                                          <span className = "col-lg-5 content-titles">
                                              Postal Address:
                                          </span>
                                          <span className = "col-lg-7 content-text">
                                            {_this.props.student_details.core_details.AddressM}
                                          </span>
                                      </div>
                                </div>



                            </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <Footer/>

      </div>
    );
  }
}

export default Dashboard;
